import { Route, Routes } from "react-router"

import { UsersListPage } from "./list/users-list-page"

export function UsersRoot() {
  return (
    <Routes>
      <Route index element={<UsersListPage />} />
    </Routes>
  )
}
